export const THE_GIVE_DATA_WAS_INVALID = 'the given data was invalid.'



// WEBPACK FOOTER //
// ./src/utils/constants/Users.js